__turbopack_context__.v({
  "desktopOnly": "yln36W_desktopOnly",
  "pulse": "yln36W_pulse",
  "shimmer": "yln36W_shimmer",
  "tile": "yln36W_tile",
});
